// extracted by mini-css-extract-plugin
export default {"drawer":"Drawer_drawer__1UhOA"};